import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "overflow-hidden w-full h-full flex justify-center items-center text-center"
}
const _hoisted_2 = {
  key: 2,
  class: "grid grid-cols-[2fr_3fr] grid-rows-2 w-full h-full justify-center items-center text-sm"
}
const _hoisted_3 = {
  key: 3,
  class: "m-auto text-sm"
}

import { computed } from "vue";
import {
  isTrans,
  isMultipleActionsInternal,
  isLayer,
  isDefaultLayer,
  isHoldTapInternal,
  isCustom,
} from "@/keyboard";
import {
  useKeycapColorsStore,
  useKeyboardStore,
  useKeycapStore,
  useHelpStore,
} from "@/stores";
import { generateColorSet } from "@/stores/keycapColors";
// Eslint can't see that this is used in template
// eslint-disable-next-line
import { TRANS_ICON } from "@/stores/keycap";
import KeyCodes from "@/components/keys/KeyCodes.vue";
import LayerAction from "@/components/keys/LayerAction.vue";
import HoldTapInner from "@/components/keys/HoldTapInner.vue";
import CustomAction from "@/components/keys/CustomAction.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'KeyCap',
  props: {
    x: {},
    y: {},
    rot: {},
    height: {},
    width: {},
    row: {},
    col: {},
    selected: { type: Boolean },
    highlighted: { type: Boolean },
    outlined: { type: Boolean },
    blank: { type: Boolean }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "5997b932": (keycapPosLeft.value),
  "4c94635e": (keycapPosRight.value),
  "8fa69cae": (-_ctx.rot + "deg"),
  "3a4fb79d": (_ctx.width + "px"),
  "5a73c8f0": (_ctx.height + "px"),
  "779209ce": (keycapFontSize.value),
  "3b985663": (colorFocus80.value),
  "d8b4285c": (colorBg.value),
  "3b985682": (colorFocus90.value),
  "c4fff5e8": (colorContent.value),
  "22d8d8d5": (colorOutline.value)
}))

const props = __props;

const colors = useKeycapColorsStore();
const kb = useKeyboardStore();
const kc = useKeycapStore();
const help = useHelpStore();

const color = computed(() => {
  const c = colors.at(props.row, props.col);
  return props.highlighted ? c.saturate(0.6).rotate(180) : c;
});
const set = computed(() => generateColorSet(color.value));

const colorBase = computed(() => set.value.base.toHex());
const colorContent = computed(() => set.value.content.toHex());
const colorFocus80 = computed(() => set.value.focus.alpha(0.8).toHex());
const colorFocus90 = computed(() => set.value.focus.alpha(0.9).toHex());
const colorContent80 = computed(() => set.value.content.alpha(0.8).toHex());

const colorOutline = computed(() =>
  set.value.content.mix(set.value.base, 0.3).darken(0.1).toHex()
);

const colorBg = computed(() =>
  props.selected ? colorFocus80.value : colorBase.value
);

const getActionOverride = () =>
  help.isKeySelected(props.row, props.col) ? help.overrideKeyAction : null;
const getTransActionOverride = () =>
  help.isKeySelected(props.row, props.col) ? help.overrideTransAction : null;

const avg_size = computed(() => (props.width + props.height) / 2);
const small_shadow = computed(() => avg_size.value < 50);

const raw_action = computed(() => {
  return getActionOverride() ?? kb.getAction(props.row, props.col);
});
// Resolve to final action if transparent
const action = computed(() => {
  const override = isTrans(raw_action.value)
    ? getTransActionOverride()
    : getActionOverride();
  const act = override ?? kb.getActionTransparent(props.row, props.col);
  return isTrans(act) ? "NoOp" : act;
});

// NOTE: scoped v-bind is buggy, it might be related to:
//  "requires that @vue/cli-service starts using newer vue-loader: https://github.com/vuejs/core/issues/3921"
// but seems to works fine if not using anything more complex than addition/subtraction in the v-bind directives.
// For this reason compute any complicated values here and use just the variable names in v-bind.
const keycapPosLeft = computed(() => props.x - props.width / 2 + "px");
const keycapPosRight = computed(() => props.y - props.height / 2 + "px");
const keycapFontSize = computed(() => 0.3 * props.height + "px");

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["keycap key-pos transition-[filter,transform] duration-500", [_ctx.highlighted ? 'scale-[115%] z-10' : '']])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        `keycap-size keycap-color keycap-transitions rounded-lg p-1 duration-500`,
        `shadow`,
        small_shadow.value
          ? `shadow-[inset_0_-1px_1px_2px] hover:shadow-[inset_0_-1px_1px_3px]`
          : `shadow-[inset_0_-2px_1px_5px] hover:shadow-[inset_0_-2px_2px_6px]`,
        _ctx.outlined ? 'keycap-outlined' : '',
      ])
    }, [
      (!_ctx.blank)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_unref(isTrans)(raw_action.value))
              ? (_openBlock(), _createBlock(_component_Icon, _mergeProps({ key: 0 }, _unref(TRANS_ICON), { class: "absolute top-2 left-2 text-[0.7em] text-color-content" }), null, 16))
              : _createCommentVNode("", true),
            (
            _unref(isHoldTapInternal)(action.value) && action.value.HoldTap.settings != undefined
          )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["absolute top-[2px] right-[9px] text-[0.7em] text-color-content tooltip", _unref(isTrans)(raw_action.value) ? 'opacity-30' : '']),
                  "data-tip": "Overrides default Hold/Tap settings"
                }, " ! ", 2))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass([
            `p-1 leading-tight font-mono flex flex-col w-full h-full justify-center items-center text-color-content`,
            _unref(isTrans)(raw_action.value) ? 'opacity-30' : '',
          ])
            }, [
              (_unref(isMultipleActionsInternal)(action.value))
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 0,
                    icon: "fluent:more-circle-32-filled",
                    class: "m-auto"
                  }))
                : (_unref(isCustom)(action.value))
                  ? (_openBlock(), _createBlock(CustomAction, {
                      key: 1,
                      action: action.value.Custom
                    }, null, 8, ["action"]))
                  : (_unref(isHoldTapInternal)(action.value) && _unref(kc).show_hold_tap)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(HoldTapInner, {
                          action: action.value.HoldTap.tap,
                          variant: "tap",
                          bgColor: colorContent80.value,
                          textColor: colorBase.value
                        }, null, 8, ["action", "bgColor", "textColor"]),
                        _createVNode(HoldTapInner, {
                          action: action.value.HoldTap.hold,
                          variant: "hold",
                          bgColor: colorContent80.value,
                          textColor: colorBase.value
                        }, null, 8, ["action", "bgColor", "textColor"])
                      ]))
                    : (_unref(isHoldTapInternal)(action.value))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Hold Tap "))
                      : (_unref(isLayer)(action.value) || _unref(isDefaultLayer)(action.value))
                        ? (_openBlock(), _createBlock(LayerAction, {
                            key: 4,
                            layer: _unref(isLayer)(action.value) ? action.value.Layer : action.value.DefaultLayer,
                            bgColor: colorContent80.value,
                            textColor: colorBase.value,
                            isDefault: _unref(isDefaultLayer)(action.value)
                          }, null, 8, ["layer", "bgColor", "textColor", "isDefault"]))
                        : (_openBlock(), _createBlock(KeyCodes, {
                            key: 5,
                            action: action.value,
                            class: "m-auto text-color-content-90",
                            max_length: 8,
                            max_lines: 3,
                            size_adjust: 0
                          }, null, 8, ["action"]))
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})